import React, { useEffect, useState, useContext } from 'react';
import { consts, icons, logoSvg } from '../services/_consts';
import CvMakerContext from '../services/app-context';
import Helper from '../services/Helper'
import { Modal } from './elemans/_elemans'
import { Navigate } from 'react-router'
import { t, lang } from '../services/_lang';

export const Login = ({ onClose, onAfterLogin, openAs = "modal" }) => {
    //for login
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    //for register
    const [userNameForReg, setUserNameForReg] = useState('');
    const [passwordForReg, setPasswordForReg] = useState('');
    const [email, setEmail] = useState('');
    //
    const [tab, setTab] = useState('login');
    const [loading, setLoding] = useState(false);
    const [redirect, setRedirect] = useState(false);

    const context = useContext(CvMakerContext);

    const loginDo = async () => {
      
        setLoding(true);
        const data = await Helper.callApiAsJson({ url: 'authenticate/Login', type: 'post', data: { userName, password } });
        setLoding(false);
        if (data && data.token) {
            context.setCurrentUser(data);
            localStorage.setItem("token", data.token);

            if (openAs == "page")
                setRedirect("/");
            if (onAfterLogin)
                onAfterLogin();
        }
        else {
            alert("invalid user or password");
        }
    }

    const register = async () => {
        setLoding(true);
        const data = await Helper.callApiAsJson({ url: 'authenticate/Register', type: 'post', data: { userName, email, password } })

        setLoding(false);
        if (data) {
            loginDo();
        }
        else {
            alert("")
        }
    }

    useEffect(() => {


        return () => {

        }
    }, [])

    if (redirect)
        return <Navigate replace to={redirect} />
    return (
        <Modal onClose={onClose} isLg='true' showHeader={openAs == "modal"} >
            <div className={`row ${context.lang.rtl && 'rtl'} ${tab == "login" ? "" : "d-none"}`}>
                <div className={`col-md-5 col-sm-12 col-xs-12 text-center position-relative`}>
                    <img src="/login_logo.png" className="d-none d-md-block" style={{
                        width: '70%',
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        left: '20px'                    }} />
                </div>
                <div className={`col-md-7 col-sm-12 col-xs-12`}>
                    <h4 className="aviny mb-3">{context.lang.login}</h4>
                    <div className="mb-4 ">
                        <div className="mb-3">
                            <label htmlFor="username" className="form-label">{context.lang.userName}</label>
                            <input value={userName} onChange={e => setUserName(e.target.value)} type="email" className="form-control" id="username" placeholder="name@example.com" />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="pass" className="form-label">{context.lang.password}</label>
                            <input value={password} onChange={e => setPassword(e.target.value)} type="password" className="form-control" id="pass" placeholder="" />
                        </div>
                        <div className="mb-3">
                            {loading ? <div className="spinner-border" role="status"></div> :
                                <button onClick={loginDo} className="btn btn-outline-dark btn-block me-1 bg-white2">{context.lang.login} <i className={icons.signIn}></i></button>
                            }
                            <br />
                            <label>{t("if_not_register")}
                                <button onClick={() => setTab('register')} className="btn btn-link btn-block me-1 bg-white2">{context.lang.register}<i class="las la-arrow-right"></i></button>
                            </label>
                        </div>

                        <div className="mt-4">
                            <div>Or Login using</div>
                            <div className="d-inline-flex ms-4">
                                <form method='POST' action={`/authenticate/ExternalLogin?provider=Google`} >
                                    {/*<input type="hidden" name="provider" value="Google" />*/}
                                    <button
                                        style={{ height: 80, width: 90 }}
                                        className="btn btn-outline-dark btn-block me-1 bg-white2"
                                        type="submit"
                                        name='provider'
                                        value='Google'
                                        title={`Login using Google`}>
                                        <span dangerouslySetInnerHTML={{ __html: logoSvg.google }}></span>
                                        Google
                                    </button>
                                </form>

                                <form method='POST' action={`/authenticate/ExternalLogin?provider=red mask`} >
                                    {/*<input type="hidden" name="provider" value="Google" />*/}
                                    <button
                                        style={{ height: 80, width: 90 }}
                                        className="btn btn-outline-dark btn-block me-1 bg-white2"
                                        type="submit"
                                        name='provider'
                                        value='red mask'
                                        title={`Login using RedMask`}>
                                        {/*<img src="/rm.svg" style={{ height: 30 }} />*/}
                                        <span dangerouslySetInnerHTML={{ __html: logoSvg.redMask }}></span>
                                        RedMask
                                    </button>
                                </form>
                            </div>

                        </div>

                    </div>
                </div>

            </div>
            <div className={`row ${context.lang.rtl && 'rtl'} ${tab == "register" ? "" : "d-none"}`}>
                <div className={`col-md-7 col-sm-12 col-xs-12 `}>
                    <h4 className="aviny mb-3">{context.lang.register}</h4>
                    <div className="mb-4">
                        <div className="mb-3">
                            <label htmlFor="username" className="form-label">{context.lang.userName}</label>
                            <input value={userNameForReg} onChange={e => setUserNameForReg(e.target.value)} type="email" className="form-control" id="username" />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">{context.lang.email}</label>
                            <input value={email} onChange={e => setEmail(e.target.value)} type="email" className="form-control" id="email" placeholder="" />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="pass" className="form-label">{context.lang.password}</label>
                            <input value={passwordForReg} onChange={e => setPasswordForReg(e.target.value)} type="password" className="form-control" id="pass" placeholder="" />
                        </div>
                        <div className="mb-3">
                            {loading ? <div className="spinner-border" role="status"></div> :
                                <button onClick={register} className="btn btn-outline-dark btn-block me-1 bg-white2">{context.lang.register} <i className={icons.signIn}></i></button>
                            }
                            <br />
                            <label>{t("if_already_member")}
                                <button onClick={() => setTab('login')} className="btn btn-link btn-block me-1 bg-white2"><i class="las la-arrow-left"></i>{context.lang.login}</button>
                            </label>
                        </div>
                    </div>
                </div>
                <div className={`col-md-5 col-sm-12 col-xs-12 text-center position-relative`}>
                    <img src="/register_logo.png"
                        className="d-none d-md-block"
                        style={{
                        width: '70%',
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        left: '20px'
                    }} />
                </div>

            </div>
        </Modal>
    );

}
export default Login;